
      import Wechat from './wechat.vue'
      import type { App, Plugin } from 'vue'

      export const WechatPlugin: Plugin = {
        install(app: App) {
          app.component('Wechat', Wechat)
        },
      }
      export { Wechat }
      